import React from "react";

const MenuIcon = () => {
  return (
    <button
      id="hamburger"
      className="rec_header_hamburger"
      aria-label="Toggle menu"
      aria-expanded="false"
    >
      <span className="rec_header_bar"></span>
      <span className="rec_header_bar"></span>
      <span className="rec_header_bar"></span>
    </button>
  );
};

export default MenuIcon;
